import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Transition } from 'react-transition-group';
import { TweenMax } from 'gsap';

import style from './index.module.scss';

class PartnershipLogo extends Component {
  render() {
    const { view: { id }, show, className, onClick, animate, image/*, layout: { mobile }*/ } = this.props;

    return (
      <Transition
        timeout={1000}
        in={show}
        addEndListener={(node, done) => {
          if (animate) {
            TweenMax.to(this.logo, { opacity: 0 });
          }
        }}
      >
        <div className={`${style.container} ${className} ${id === 'results' ? style.results : ''}`} onClick={onClick ? onClick.bind(this) : null} ref={instance => this.logo = instance}>
          <img className={`${style.image}`} src={image ? image : `./partnership-logo.horizontal.png`} alt="logo" />
        </div>
      </Transition>
    );
  }
}

const mapStateToProps = state => ({
  view: state.view,
  quiz: state.quiz,
  layout: state.layout
});

export default connect(mapStateToProps)(PartnershipLogo);
